import { FilterOption } from '../types';

// Takes a string in the format "YYYY-MM-DD" and turns it into date object
const dateStringToObj = (date: string | undefined) => {
  if (date && date.match(/^\d{4}-\d{2}-\d{2}/)) {
    const splitDate = date.split('-');

    return new Date(parseInt(splitDate[0]), parseInt(splitDate[1]) - 1, parseInt(splitDate[2]));
  }

  return null;
};

// Takes a string in the format "value|label" and calls function callback(value, label)
const splitOptionString = (str, callback) => {
  if (str) {
    const items = str.split('&');

    items.forEach((item) => {
      const splitItem = item.split('|');

      if (splitItem.length === 2) {
        callback(splitItem[0], splitItem[1]);
      }
    });
  }
};

// Converts two strings in the format "YYYY-MM-DD" to [Date, Date]
export const dateRangeConvert = (startDate: string | undefined, endDate: string | undefined) => {
  const start: Date | null = dateStringToObj(startDate);
  const end: Date | null = dateStringToObj(endDate);

  return [start, end];
};

// Converts [{value, label}] into "value|label&"
export const optionsToString = (arr: Array<FilterOption> | undefined) => {
  if (arr && arr.length) {
    let str = '';

    arr.forEach((item) => {
      str += item.value + '|' + item.label + '&';
    });

    return str;
  }

  return null;
};

// Converts "value|label&" into [{value, label}]
export const stringToOptions = (str: string | undefined) => {
  if (str) {
    const arr: Array<FilterOption> = [];

    splitOptionString(str, (value, label) => {
      arr.push({ value, label });
    });

    return arr;
  }

  return [];
};

// Converts "value|label&" into [value]
export const stringToValues = (str: string | undefined) => {
  const arr: Array<string> = [];

  splitOptionString(str, (value) => {
    arr.push(value);
  });

  return arr;
};
